import React from 'react'
import { Popover as PopoverHeadless, Transition } from '@headlessui/react'
import classNames from 'classnames'
import propTypes from 'prop-types'


export default function Popover(props) {
  return (
    <PopoverHeadless className='relative inline-block'>
      {({ open }) => (
        <>
          <PopoverHeadless.Button
            as={React.Fragment}
          >
            {props.handler}
          </PopoverHeadless.Button>
          <Transition
            show={open}
            as={React.Fragment}
            enter='transition ease-out duration-200'
            enterFrom='opacity-0 translate-y-1'
            enterTo='opacity-100 translate-y-0'
            leave='transition ease-in duration-150'
            leaveFrom='opacity-100 translate-y-0'
            leaveTo='opacity-0 translate-y-1'
          >
            <PopoverHeadless.Panel
              className={classNames([
                props.panelClassName,
                'absolute bottom-full z-50 shadow-lg',
                'p-5 mb-2 w-52',
                'max-w-xl',
                'transform',
                {
                  '-translate-x-1/2 left-1/2': props.position === 'center',
                  'left-0': props.position === 'left',
                  'right-0': props.position === 'right',
                },
                'bg-white block',
                'text-left no-underline break-words',
                'rounded-lg',
              ])}
            >
              {props.children}
            </PopoverHeadless.Panel>
          </Transition>
        </>
      )}
    </PopoverHeadless>
  )
}

Popover.propTypes = {
  position: propTypes.oneOf(['center', 'left', 'right']),
  handler: propTypes.any.isRequired,
  panelClassName: propTypes.string,
}

Popover.defaultProps = {
  position: 'center',
}
